<template>
  <CustomModal
    noPadding
    class="create-new-hotel-offer"
    :is-modal-open="isOpen"
    @toggleModal="closeModal"
    @onClickAway="closeModal"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:max-w-[768px] tw:md:w-[768px] tw:md:rounded-md tw:rounded-none'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">
        {{ $t('hotel_offers_overlay_list') }}
      </p>
    </template>

    <div class="tw:w-full">
      <div class="tw:px-6">
        <div>
          <HotelOffersFilter
            :filteringCategories="filteringCategories.filter(item => item.value !== 'vouchers')"
            :selectedFilter="selectedFilter"
            @selectFilter="selectFilter"
            dataTestIdLocation="modal"
          />
          <div class="tw:max-h-[300px] tw:overflow-auto tw:px-1 tw:flex tw:flex-col tw:gap-y-3 tw:mb-3">
            <HotelOfferModalItem
              v-for="(item, index) in filteredTemplates.filter(item => item.status === 'ACTIVE')"
              :isClickable="false"
              :key="index"
              :item="item"
              :icons="icons"
            />
          </div>
        </div>
      </div>
    </div>

    <template #modalFooter>
      <div class="tw:flex tw:w-full tw:justify-end tw:gap-x-4">
        <MainButton @click="closeModal">
          {{ $t('hotel_offers_overlay_ok') }}
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import { ref, computed, watch } from 'vue'

import CustomModal from '@/components/base/CustomModal.vue'

import MainButton from '@/components/base/buttons/MainButton.vue'
import HotelOfferModalItem from '@/components/hotelOffers/createOffer/HotelOfferModalItem.vue'
import HotelOffersFilter from '@/components/hotelOffers/HotelOffersFilter.vue'
import { useOffersTemplates } from '@/components/hotelOffers/queries'
import { useHotelOffers } from '@/components/hotelOffers/useHotelOffers'
import icons from '@/constants/hotelOffersIcons'

const { templates, categories } = useOffersTemplates()

const emit = defineEmits(['closeModal'])
const closeModal = () => emit('closeModal')
defineProps({
  isOpen: Boolean,
})

const { categoryNames } = useHotelOffers()

const selectedFilter = ref('all')
const filteringCategories = computed(() => {
  let allCategories = [{ value: 'all', label: categoryNames['all'] }]
  let newCategories =
    categories.value?.length > 0
      ? categories.value.map(category => {
          return {
            value: category,
            label: categoryNames[category],
          }
        })
      : []

  return [...allCategories, ...newCategories]
})

const filteredTemplates = ref([])

const selectFilter = selectedValue => {
  selectedFilter.value = selectedValue
}

watch(
  [templates, selectedFilter],
  ([newTemplates, filter]) => {
    if (filter === 'all') {
      filteredTemplates.value = newTemplates
    } else {
      filteredTemplates.value = newTemplates.filter(item => item.category === filter)
    }
  },
  { immediate: true }
)
</script>
